import React from 'react';
import Orientation2025 from '../views/Orientation2025';

const ExtraCurricularActivitiesPage = () => {
  return <Orientation2025 />;
};

export default ExtraCurricularActivitiesPage;